import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { BrewSheet } from '@/components/recipe/brew-sheet';
import { useReturn } from '@/lib/return-ticket';

export const Route = createFileRoute('/recipes/$recipeId/sheet')({
  component: BrewSheetPage,
});

function BrewSheetPage() {
  const { recipeId } = Route.useParams();
  const navigate = useNavigate();
  // Back to the recipe's own entry when the sheet was opened from it — which
  // still carries the list's ticket, so the press after that reaches the list
  // (PLAN-LIST-STATE D-LS8). A sheet reached any other way pushes the recipe,
  // exactly as it did before.
  const toRecipe = useReturn(() => {
    void navigate({ to: '/recipes/$recipeId', params: { recipeId } });
  });
  // A sheet whose recipe is not here offers "Back to recipes", and means it:
  // the list, not the missing recipe `toRecipe` would open. A plain push,
  // because this entry's ticket names the recipe, not the list.
  const toRecipes = () => {
    void navigate({ to: '/recipes' });
  };
  // Keyed for the reason the recipe page is (see `index.tsx`): a sheet reused
  // across a param change would keep what it was holding for the recipe before
  // it. Each sheet is a new mount.
  return <BrewSheet key={recipeId} recipeId={recipeId} onBack={toRecipe} onRecipes={toRecipes} />;
}
